export default __webpack_public_path__ + "static/avatar-special-halloween-0-cover-bfff0682d0810a89c76251ce4ec0f592.png";